export enum ScreenKinds {
  None = 1,
  Department = 2,
  Doctor = 3,
  List = 4,
  HospitalDestination = 5,
}
